import React from 'react'
import ReactTable from "react-table";
import Workbook from 'react-excel-workbook'
import { filterCaseInsensitive } from '../../../../utils/commonUtility'
import DotLoader from '../../Loader/DotLoader.component'
import { ROLE } from '../../../../utils/Constant';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import ScoringPopupviewMain from '../../../containers/Admin/CreditModule/scoring/ScoringViewPopup/Main'
import LogsInactive from '../../../../images/rewampimages/logsinactive.png'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import CustomerChatOptionPopup from './CustomerChatOptions/CustomerChatOptionPopup';
import { EmailcheckFn, SuperUsercheck } from '../../../../utils/CustomEmailCheck';
const ApplicationStatus = ({ changeBucket, bucketType, statsData, formStatusList, handleStepChange, steps, CustomStepIcon, filterData, startDateToshow, endDateToshow, dateHandle, formStatus, statusHandler, paginationHandler, phocketTablePagination, tableMaxPagination, tableMinPagination, admin, allUserDetail, backpage, forwordpage, dataFilter,
    deleteUserHandler, isDeleteUser, editUserHandler, loadarState, unsubscribeHandler,
    getFilterValue, FilteredData, getPageValue, pageIndexToShow, varifyMobile, teaGardenData, teaGardenId, teaChangeHandler, InternalScoringPopup, handleInternalScoringPopup, handleCommLogsPopup, commPopupData, PopupbuttonHandle, showPopupTabsValue, HandlePopupAddBtn, AddCommentHandler, SaveCommentInPopup, communicationDetailType, handlecommunicationDetailTypechange, AddCallDetailHandler,
    SaveCallDetailInPopup, communicationList, PopupViewTab, commentData, AmuDecisionHandler, amuDecision, handledownloadExcel, pageViewHandler, panNumberSearched, handleOpenchatTab, chatTaboption, handleUserType, userType,flowType,handleFlowType }) => (
    <div className="container-fluid">
        {/* <div className="row">
            <div className="col-xs-12">
                <h3 className="text-center blue-text">Application Status</h3>
            </div>
        </div> */}
        <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '0px' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
            <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
            <h5 style={{ cursor: 'pointer' }}>Back</h5>
        </div>
        <div className='row'>
            <div className='col-sm-2 col-xs-12'>
                <label>Start Date</label>
                <input value={startDateToshow} onChange={(e) => dateHandle(e, 'start')} className='form-control' type='date' />
            </div>
            <div className='col-sm-2 col-xs-12'>
                <label>End Date</label>
                <input value={endDateToshow} onChange={(e) => dateHandle(e, 'end')} className='form-control' type='date' />
            </div>
            <div className='col-sm-1 col-xs-12'>
                <button className='btn btn-primary' onClick={() => filterData()} style={{ marginTop: '20px', padding: '10px' }}>Filter</button>
            </div>
            <div className='col-sm-5 col-xs-12'>
                <div className='row'>
                    <div className='col-sm-4 col-xs-12'>
                        {/* <button className={bucketType === 'p1' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p1')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 1</button> */}
                        <button className={userType === 'BORROWER' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => handleUserType('BORROWER')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Borrower</button>

                    </div>
                    <div className='col-sm-4 col-xs-12'>
                        {/* <button className={bucketType === 'p2' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p2')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 2</button> */}
                        <button className={userType === 'COBORROWER' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => handleUserType('COBORROWER')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Co-Borrower</button>

                    </div>
                    <div className='col-sm-4 col-xs-12'>
                        {/* <button className={bucketType === 'p3' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p3')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 3</button> */}
                        <button className={userType === 'GUARANTOR' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => handleUserType('GUARANTOR')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Guarantor</button>

                    </div>

                </div>
            </div>
            <div className='col-sm-2 col-xs-12' >
                {statsData !== '' ?
                    // <button className={bucketType === '' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Total Counts : {statsData !== '' ? statsData.totalCount : ""}</button>
                    <button className={'btn btn-primary'} onClick={() => handleUserType('BORROWER')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Total Counts : {statsData !== '' ? statsData.totalCount : ""}</button>

                    // <div
                    // onClick={() => changeBucket('')}
                    //     className='new-card-market shadow"'>
                    //     <div style={{ color: 'grey' }}> Total Counts : <b>{statsData !== '' ? statsData.totalCount : ""}</b></div><br />
                    //     {/* <b style={{ fontSize: '18px' }}></b> */}
                    // </div>
                    : ""}
            </div>
        </div>

        <div className="row form-group" style={{ marginTop: '20px' }}>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px"><span className="fa fa-search" /> Email ID</label>
                <input type="email" className="form-control" onChange={e => dataFilter(e, "email")} />
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" ><span className="fa fa-search" /> Mobile No.</label>
                <input type="number" onChange={e => dataFilter(e, "mobileNo")} className="form-control" />
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" ><span className="fa fa-search" /> PAN No.</label>
                <input type="text" value={panNumberSearched} onChange={e => dataFilter(e, "panNo")} className="form-control" />
            </div>
            {/* <div className='col-sm-2 col-xs-12'>
                <label>Select Tea Garden</label>
                <select className='form-control' value={teaGardenId} onChange={(e) => teaChangeHandler(e, 'teaGardenId')}>
                    <option value=''>Select Tea Garden</option>

                    {teaGardenData ? teaGardenData.map((data, i) => {
                        return (
                            <option value={data.teaGardenId}>{data.tea_garden_name}</option>

                        )
                    }) : ""}
                </select>
            </div> */}
            <div className='col-sm-2 col-xs-12'>
                <label>Select Form Status</label>
                <select className='form-control' value={formStatus} onChange={(e) => statusHandler(e)}>
                    <option value=''>Select Form Status</option>
                    {formStatusList?.length > 0 ?
                        formStatusList.map((data, i) => {
                            const formStatusText = data == "BasicDetails" ? "Basic Details" : data == "PermanentAddress" || data == "permanentaddressl5" ? "Permanent Address" : data == "MobileVerification" || data == "mobileverificationl5" ? "Mobile Verification" : data == "SoftApproval" || data == "softapprovall5" ? "Soft Approval" : data == "EmploymentDetails" || data == "employmentdetailsl5" ? "Employment Details" : data == "CurrentAddress" || data == "currentaddressl5" ? "Current Address" : data == "BankDetails" ? "Bank Details" : data == "UploadPhoto" ? "Upload Photo" : data == "incomeDetails" || data == "incomedetailsl5" ? "Income Details" : data == "LoanDetails" || data == "loandetailsl5" ? "Loan Details" : data == "AssetsVehicles" || data == "assetsvehiclesl5" ? "Assets Vehicles" : data == "InsuranceDetails" ? "Insurance Details" : data == "InvoiceDetails" ? "Invoice Details" : data == "uploaddocuments" ? "Upload Documents" : data == "uploaddocumentspost" || data == "uploaddocumentspostl5" ? "Upload Documents Post" : data == "addcoborrower" ? "Add Co-Borrower" : data == "aadhaarl5" ? "Aadhaar" : data == "basicdetailsl5" ? "Basic Details" : data == "referencel5" || data == "reference" ? "Reference" : data == "vkycl5" ? "VKYC" : data == "fil5" || data == "fi" ? "FI" : data == "uploadphotol5" ? "Upload Photo": data == "leadsl5" ? "Leads" : data == "esign" ? "E-Sign" : data == "addgurantor" ? "Add Guarantor" : data
                            return (
                                <option value={data}>{formStatusText}</option>
                            )
                        })


                        : ""}

                </select>
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" >Flow Type</label>
                 <select value={flowType} onChange={(e) => handleFlowType(e)} className="form-control" >
                    <option value={""}>Select Option</option>
                    <option value={"L3"}>L3</option>
                    <option value={"L5"}>L5</option>
                    <option value={"BATTERY"}>BATTERY</option>
                   
                </select>
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" >AMU Decision</label>
                <select value={amuDecision} onChange={(e) => AmuDecisionHandler(e, 'breDecision')} className="form-control" >
                    <option value={""}>Select Option</option>
                    <option value={"Approved"}>Approved</option>
                    <option value={"Approved Manual"}>Approved Manual</option>
                    <option value={"Additional Credit Review Required"}>Additional Credit Review Required</option>
                    <option value={"Rejected"}>Rejected</option>
                    <option value={"Rejected Manual"}>Rejected Manual</option>
                    <option value={"ABNI"}>Approved But Not Interested</option>
                </select>
            </div>


        </div>
        <div className="row">
            <div className='col-sm-2 col-xs-12' style={{ marginTop: '22px' }}>
                {admin && admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 ?
                    // <Workbook filename="ApplicationStatus.xlsx" element={<button className="profile-save-btn margin-0"><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>}>
                    //     <Workbook.Sheet data={allUserDetail} name="Sheet A">
                    //         <Workbook.Column label="first Name" value="firstName" />
                    //         <Workbook.Column label="middle Name" value="middleName" />
                    //         <Workbook.Column label="last Name" value="lastName" />
                    //         <Workbook.Column label="email Id" value="emailId" />
                    //         <Workbook.Column label="mobile Number" value="mobileNumber" />
                    //         <Workbook.Column label="pan Number" value="panNumber" />
                    //         <Workbook.Column label="form Status" value="formStatus" />
                    //         <Workbook.Column label="Dealer Name" value="communityName" />
                    //         <Workbook.Column label="Agent Name" value="agentName" />
                    //         <Workbook.Column label="Login Date" value="loginDate" />
                    //         <Workbook.Column label="address" value="address" />
                    //         <Workbook.Column label="state" value="state" />
                    //         <Workbook.Column label="AMU Decision" value="breDecision" />
                    //     </Workbook.Sheet>
                    // </Workbook>
                    <button className="profile-save-btn margin-0" onClick={() => handledownloadExcel()}><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>
                    : ""}
            </div>
        </div>
        {/* <div className=" mui-ste" >
            <div className="shadow" style={{ overflowX: 'auto' }}>
                <Box sx={{ width: '100%', marginTop: '50px' }}>
                    <Stepper alternativeLabel>
                        {steps.length > 0 ? steps.map((step, index) => (
                            <Step key={step.label} onClick={() => handleStepChange(index)}>
                                <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={step.index} data={step} />} />
                                <div className="text-center" style={{ marginTop: '10px' }}>
                                    
                                    {step.label == "BasicDetails" ? "Basic Details" : step.label == "PermanentAddress" ? "Permanent Address" : step.label == "MobileVerification" ? "Mobile Verification" : step.label == "SoftApproval" ? "Soft Approval" : step.label == "EmploymentDetails" ? "Employment Details" : step.label == "CurrentAddress" ? "Current Address" : step.label == "BankDetails" ? "Bank Details" : step.label == "UploadPhoto" ? "Upload Photo" : step.label == "incomeDetails" ? "Income Details" : step.label == "LoanDetails" ? "Loan Details" : step.label == "AssetsVehicles" ? "Assets Vehicles" : step.label == "InsuranceDetails" ? "Insurance Details" : step.label == "InvoiceDetails" ? "Invoice Details" : step.label == "uploaddocuments" ? "Upload Documents" : step.label == "uploaddocumentspost" ? "Upload Documents Post" : step.label == "addcoborrower" ? "Add Co-Borrower" : step.label == "leads" ? "Leads" : step.label == "fi" ? "FI" : step.label == "esign" ? "E-Sign" : step.label == "addgurantor" ? "Add Guarantor" : step.label == "reference" ? "Reference" : step.label}
                                </div>
                            </Step>
                        )) : ""}
                    </Stepper>
                </Box>
            </div>
        </div> */}
        <div className="row form-group">

            <div className="col-xs-6 text-left">
                {/* {admin && admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 ?
                    <Workbook filename="ApplicationStatus.xlsx" element={<button className="profile-save-btn margin-0"><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>}>
                        <Workbook.Sheet data={allUserDetail} name="Sheet A">
                            <Workbook.Column label="firstName" value="firstName" />
                            <Workbook.Column label="emailId" value="emailId" />
                            <Workbook.Column label="mobileNumber" value="mobileNumber" />
                            <Workbook.Column label="panNumber" value="panNumber" />
                            <Workbook.Column label="formStatus" value="formStatus" />
                        </Workbook.Sheet>
                    </Workbook>
                    : ""} */}
            </div>
            <div className="col-xs-6 text-right">
                {/* <button className="admin-pagination-btn" id="backword" onClick={e => backpage()}><span className="fa fa-chevron-left" /></button>
                <button className="admin-pagination-btn" id="forword" onClick={e => forwordpage()}><span className="fa fa-chevron-right" /></button> */}
                {/* <p>1-100</p> */}
            </div>
        </div>
        <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-xs-12 no-padding overflow-auto">
                {loadarState == false ?
                    allUserDetail != null ? allUserDetail.length > 0 ?
                        <table className='phocket-table'>
                            <thead>
                                <tr>
                                    <td>Form Step</td>
                                    <td>Details</td>
                                    <td>First Name</td>
                                    <td>Mobile Verified</td>
                                    <td>Email Id</td>
                                    <td>Login Date</td>
                                    <td>State</td>
                                    <td>Phone Number</td>
                                    <td>Dealer Name</td>
                                    <td>Fields Executive</td>
                                    <td>Spoke location</td>
                                    {
                                        userType === 'BORROWER' ? "" : <>
                                            <td>Borrower Name</td>
                                            <td>Borrower Pan no.</td>
                                        </>
                                    }

                                    {/* {admin && EmailcheckFn(admin.emailId,SuperUsercheck) && userType === 'BORROWER' ?
                                        <td>Unsubscribe</td>
                                        : ""} */}
                                    <td>User Id</td>
                                    {
                                        userType === 'BORROWER' ?
                                            <>
                                                <td>Co-Borrower</td>
                                                <td>Guarantor</td>
                                            </> : ""}
                                    <td>AMU Decision</td>
                                    <td>Logs</td>
                                    <td>Analysis</td>
                                    {/* {
                                        userType === 'BORROWER' ?
                                            <td>Chat</td>
                                            : ""} */}
                                    {admin && EmailcheckFn(admin.emailId,SuperUsercheck) ?
                                        <td>Delete</td>
                                        : ""}
                                    {admin && EmailcheckFn(admin.emailId,SuperUsercheck) ?
                                        <td>Verify</td>
                                        : ""}

                                </tr>
                            </thead>

                            <tbody>
                                {allUserDetail && allUserDetail.slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                    return (
                                        <tr>
                                            <td>{data.formStatus}</td>
                                            <td><button onClick={e => editUserHandler(data)}><span className="fa fa-info-circle" /></button></td>
                                            <td> {data.firstName}</td>
                                            <td> <div style={{ textAlign: 'center' }}>
                                                {data.mobileVerified === true || data.mobileVerified === 'true' ?
                                                    <i class="fa fa-check" style={{ color: 'green' }}></i>
                                                    :
                                                    <i class="fa fa-close" style={{ color: 'red' }}></i>
                                                }
                                            </div></td>
                                            <td>{data.emailId}</td>
                                            <td>{data.loginDate}</td>
                                            <td>{data.state}</td>
                                            <td>{data.mobileNumber}</td>
                                            <td>{data.communityName}</td>
                                            <td>{data.agentName}</td>
                                            <td>{data?.spoke}</td>
                                            {
                                                userType === 'BORROWER' ? "" : <>
                                            <td>{data.borrowerName}</td>
                                            <td>{data.borrowerPanNo}</td>
                                                </>
                                            }

                                            {/* {admin && EmailcheckFn(admin.emailId,SuperUsercheck) && userType === 'BORROWER' ?
                                                <td> <button className="unsubscribe-btn" onClick={e => unsubscribeHandler(data.userId)}>Unsubscribe</button></td> : ""} */}
                                            <td>{data.userId}</td>
                                            {
                                                userType === 'BORROWER' ?
                                                    <>
                                                        <td>{data?.coborrower == true ? "Yes" : "No"}</td>
                                                        <td>{data?.guarantor == true ? "Yes" : "No"}</td>
                                                    </>
                                                    : ""}
                                            <td>{data.breDecision}</td>
                                            <td><img src={LogsInactive} style={{ width: '27px', cursor: 'pointer' }} onClick={() => handleCommLogsPopup(true, data)} /></td>
                                            <td><i class="fa fa-eye" aria-hidden="true" onClick={() => handleInternalScoringPopup(true, data)}></i></td>
                                            {/* {
                                                userType === 'BORROWER' ?
                                                    <td>
                                                        <div style={{ position: 'relative' }}>
                                                            <HeadsetMicIcon style={{ cursor: 'pointer' }} onClick={() => handleOpenchatTab(true, data)} />
                                                            {
                                                                data?.lastMsgSeen == false ?
                                                                    <span style={{ background: 'green', borderRadius: '50%', width: '10px', height: '10px', position: 'absolute', top: '-3px', right: '4px' }}></span>
                                                                    : ''}
                                                        </div>

                                                    </td>
                                                    : ""} */}
                                            {admin && EmailcheckFn(admin.emailId,SuperUsercheck) ?
                                                <td> <button onClick={e => deleteUserHandler(data.userId)}><span className="fa fa-trash" /></button></td> : ""}
                                            {admin && EmailcheckFn(admin.emailId,SuperUsercheck) ?
                                                <td> <button onClick={e => varifyMobile(data.userId)}><span className="fa fa-save" /></button></td> : ""}

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>


                        : "" : "" :
                    <DotLoader />}

            </div>
            {!loadarState ?
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                        <div className="col-sm-3 col-xs-12 no-padding"><button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block red  " onClick={e => phocketTablePagination(allUserDetail, 'back')}></button></div>
                        <div className="col-sm-2 col-xs-12  phoc text-center" >{(tableMinPagination + 1) + ' - ' + (tableMaxPagination) + ' of ' + allUserDetail.length}</div>
                        <div className="col-sm-3 col-xs-12 no-padding" ><button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block red" onClick={e => phocketTablePagination(allUserDetail, 'forward')}></button></div>
                        <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                </div>
                : ""}

            {
                InternalScoringPopup.show ?
                    <ScoringPopupviewMain type={"borrower"} LeadData={InternalScoringPopup.data} closePopupbtn={handleInternalScoringPopup} admin={admin} />
                    : ''}

            {
                commPopupData.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: 'auto' }}>
                            <i onClick={() => handleCommLogsPopup(false, {})} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div>
                                <h4 className='text-center'>{commPopupData?.dataValue?.firstName + " " + commPopupData?.dataValue?.lastName}</h4>
                            </div>
                            <div className="row" style={{ marginTop: '30px' }}>
                                <div className="col-sm-12 btn-group btn-grp-own-logs">
                                    <button className="btn btn-outline-primary" style={{ borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', background: PopupViewTab === 'communication' ? '#1D3557' : '#F1F7FF', color: PopupViewTab === 'communication' ? '#fff' : '#000', zIndex: 0, width: '50%' }} onClick={() => PopupbuttonHandle('communication')}> Communication Logs </button>

                                    <button className="btn btn-outline-primary" style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px', background: PopupViewTab === 'comment' ? '#1D3557' : '#F1F7FF', color: PopupViewTab === 'comment' ? '#fff' : '#000', zIndex: 0, width: '50%' }} onClick={() => PopupbuttonHandle('comment')} >Comments </button>
                                </div>
                            </div>
                            {
                                PopupViewTab === 'comment' ?
                                    <>
                                        {
                                            showPopupTabsValue?.commentOption == false ?
                                                <div className="row from-group" >
                                                    <div className="col-xs-12" style={{ padding: '10px', margin: '20px 0' }}>
                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => HandlePopupAddBtn("comment", "open")}><i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Comment</button>
                                                    </div>
                                                </div>
                                                : ''}
                                        {
                                            showPopupTabsValue?.commentOption == true ?
                                                <>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                                            <h4 className="" style={{ marginBottom: '10px', marginTop: '10px' }}>Add Comment</h4>
                                                        </div>
                                                    </div>
                                                    {/* {console.log("RemarksListData",RemarksListData)}
                                                    {
                                                        RemarksListData && RemarksListData?.length > 0 ?
                                                            <div className="row from-group" >
                                                                <div className="col-sm-3 col-xs-12">
                                                                    <select className='form-control' value={RemarksType} onChange={(e) => handleRemarkType(e)}>
                                                                        <option value="">Select Comment</option>
                                                                        {
                                                                            RemarksListData?.map((value) => (
                                                                                <option value={value}>{value}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            : ''} */}

                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-sm-12 col-xs-12">
                                                            <textarea className='form-control' placeholder='type here...' onChange={(e) => AddCommentHandler(e)} />
                                                        </div>
                                                    </div>


                                                    <div className="row from-group text-center" >
                                                        <div className="col-xs-12">
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF', marginRight: '10px' }} onClick={() => HandlePopupAddBtn("comment", "close")}>Close</button>
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => SaveCommentInPopup()}>Add</button></div>
                                                    </div>

                                                    <hr style={{ margin: '20px 0' }} />
                                                </>
                                                : ''}

                                        <div style={{ height: '250px', overflowY: 'auto', marginTop: '30px' }}>
                                            <table className='phocket-table'>
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>Comment</td>
                                                        <td>Added By</td>
                                                        <td>Added At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {commentData && commentData?.commentList?.length > 0 && commentData?.commentList?.map((data, i) => {
                                                        return (
                                                            <tr>
                                                                <td>{data?.comment || "-"}</td>
                                                                <td> {data?.commentBy || "-"} </td>
                                                                <td> {data?.addedAt || "-"} </td>

                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                    : ''}
                            {
                                PopupViewTab === 'communication' ?
                                    <>
                                        {
                                            showPopupTabsValue?.callOption == false ?
                                                <div className="row from-group" >
                                                    <div className="col-xs-12" style={{ padding: '10px', margin: '20px 0' }}>
                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => HandlePopupAddBtn("call", "open")}><i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Communication Details</button>
                                                    </div>
                                                </div>
                                                : ''}
                                        {
                                            showPopupTabsValue?.callOption == true ?
                                                <>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                                            <h4 className="" style={{ marginBottom: '10px', marginTop: '10px' }}>Add Communication Details</h4>
                                                        </div>
                                                    </div>
                                                    <div className="row from-group" >
                                                        <div className="col-sm-3 col-xs-12">
                                                            <select className='form-control' value={communicationDetailType} onChange={(e) => handlecommunicationDetailTypechange(e)}>
                                                                <option value="">Select Communication Type</option>
                                                                <option value="mail">Mail</option>
                                                                <option value="call">Call</option>
                                                                <option value="sms">SMS</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-sm-12 col-xs-12" >
                                                            <textarea className='form-control' placeholder='type here...' onChange={(e) => AddCallDetailHandler(e)} />
                                                        </div>
                                                    </div>
                                                    <div className="row from-group text-center">
                                                        <div className="col-xs-12">
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF', marginRight: '10px' }} onClick={() => HandlePopupAddBtn("call", "close")}>Close</button>
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} disabled={communicationDetailType == "" || communicationDetailType == undefined || communicationDetailType == null ? true : false} onClick={() => SaveCallDetailInPopup()}>Add</button></div>
                                                    </div>
                                                    <hr style={{ margin: '20px 0' }} />
                                                </>
                                                : ''}
                                        <div style={{ height: '250px', overflowY: 'auto' }}>
                                            <table className='phocket-table' >
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>Employee ID</td>
                                                        <td>Communication Type</td>
                                                        <td>Communication Message</td>
                                                        <td>Form Status</td>
                                                        <td>Added At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {communicationList && communicationList?.length > 0 && communicationList?.map((data, i) => {
                                                        return (
                                                            <tr>
                                                                <td>{data?.empId || "-"}</td>
                                                                <td> {data?.communicationType || "-"} </td>
                                                                <td> {data?.body || "-"} </td>
                                                                <td> {data?.formStatus || "-"} </td>
                                                                <td> {data?.createdAt || "-"} </td>

                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                    : ''}
                        </div>
                    </div>
                    : ''}

            {
                chatTaboption?.show ?
                    <div className='details-new'>
                        <CustomerChatOptionPopup
                            handleOpenchatTab={handleOpenchatTab}
                            chatTaboption={chatTaboption}
                            admin={admin}
                        />
                    </div>
                    : ''}

        </div>
    </div>
)

export default ApplicationStatus;